export type Lang = 'pt-BR' | 'en'

export const SITE = {
  name: 'Bravic',
  hosts: {
    'pt-BR': 'https://bravicglobal.com.br',
    en: 'https://bravicglobal.com',
  } as Record<Lang, string>,
  defaultOgImage: '/og-default.png',
  contactEmail: {
    'pt-BR': 'contato@bravicglobal.com.br',
    en: 'contact@bravicglobal.com',
  } as Record<Lang, string>,
  socials: [
    'https://www.linkedin.com/company/bravic-global',
    'https://www.instagram.com/bravic.global/',
  ],
}

export function resolveLang(lang: string | undefined): Lang {
  return lang === 'en' ? 'en' : 'pt-BR'
}

export function siteUrl(lang: Lang, path: string = '/'): string {
  const host = SITE.hosts[lang]
  if (!path || path === '/') return host
  return host + (path.startsWith('/') ? path : `/${path}`)
}
